module.exports = __webpack_public_path__ + "uploadPrivatesSample.2223fd3fbc0e128a7bbba483bef06506.png";